var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "orderInfo" }, [
    _c("p", { staticClass: "title" }, [_vm._v("2.订餐信息")]),
    _c("div", { staticClass: "g-content" }, [
      _c("ul", [
        _vm.fromTypeName
          ? _c("li", [
              _c("div", { staticClass: "z-title" }, [_vm._v("下单渠道")]),
              _c("div", { staticClass: "z-content" }, [
                _vm._v("\n          " + _vm._s(_vm.fromTypeName) + "\n        ")
              ])
            ])
          : _vm._e(),
        _c("li", [
          _c("div", { staticClass: "z-title" }, [_vm._v("业务类型")]),
          _c(
            "div",
            { staticClass: "z-content" },
            [
              _vm.businessType.length
                ? [
                    _vm._l(_vm.businessType, function(item, index) {
                      return [
                        item != 3
                          ? _c(
                              "span",
                              {
                                key: index,
                                staticClass: "send-type",
                                class: {
                                  "send-type-checked":
                                    _vm.businessActive == item
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.changeSendType2(item, index)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      item == 1
                                        ? "外卖"
                                        : item == 2
                                        ? "自取"
                                        : item == 4
                                        ? "外卖预约"
                                        : ""
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        ]),
        _vm.businessType.includes(_vm.businessActive)
          ? _c("li", [
              _c("div", { staticClass: "z-title" }, [
                _vm._v(
                  _vm._s(_vm.businessActive == 2 ? "自取时间" : "预计送达时间")
                )
              ]),
              _c("div", { staticClass: "z-content" }, [
                _vm.businessActive != 1
                  ? _c("div", [
                      _vm.isModifyTime
                        ? _c("div", [
                            _c("span", [_vm._v(_vm._s(_vm.reservationTime))])
                          ])
                        : _c("div", [
                            _c(
                              "div",
                              { staticClass: "am-inline-block" },
                              [
                                _c("cc-select", {
                                  staticClass: "am-text-middle",
                                  attrs: {
                                    options: _vm.storeDateList,
                                    placeholder: "请选择日期"
                                  },
                                  on: { change: _vm.handleCheckDate },
                                  model: {
                                    value: _vm.storeDateValue,
                                    callback: function($$v) {
                                      _vm.storeDateValue = $$v
                                    },
                                    expression: "storeDateValue"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "am-inline-block am-margin-left-sm"
                              },
                              [
                                _c("cc-select", {
                                  staticClass: "am-text-middle",
                                  attrs: {
                                    options: _vm.storeTimeList,
                                    placeholder: "请选择时间"
                                  },
                                  on: { change: _vm.handleCheckTime },
                                  model: {
                                    value: _vm.storeTimeValue,
                                    callback: function($$v) {
                                      _vm.storeTimeValue = $$v
                                    },
                                    expression: "storeTimeValue"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                    ])
                  : _c("div", [_c("span", [_vm._v(_vm._s(_vm.estimateTime))])]),
                _c(
                  "div",
                  { staticClass: "am-inline-block am-margin-left-sm" },
                  [
                    _vm.isModifyTime
                      ? _c("span", [
                          _c(
                            "a",
                            {
                              staticClass: "light am-margin-left-sm",
                              on: { click: _vm.modifyTime }
                            },
                            [_vm._v("修改")]
                          )
                        ])
                      : _c("span", [
                          _c(
                            "a",
                            {
                              staticClass: "light am-margin-left-sm",
                              on: { click: _vm.cancelTime }
                            },
                            [_vm._v("取消")]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "light am-margin-left-sm",
                              on: { click: _vm.saveTime }
                            },
                            [_vm._v("保存")]
                          )
                        ])
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm.businessType.includes(_vm.businessActive)
          ? _c("li", [
              _vm.sendTime
                ? _c("div", [
                    _vm._v(
                      "原订单" +
                        _vm._s(
                          _vm.businessActive == 2 ? "自取时间" : "预计送达时间"
                        ) +
                        " "
                    ),
                    _c("span", { staticStyle: { "margin-left": "5px" } }, [
                      _vm._v(_vm._s(_vm.sendTime))
                    ])
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _c("li", [
          _vm.sendType == 1 || _vm.sendType == 4
            ? _c("div", { staticClass: "z-title" }, [_vm._v("送餐省份")])
            : _c("div", { staticClass: "z-title" }, [_vm._v("取餐省份")]),
          _c("div", { staticClass: "z-content" }, [
            _c(
              "div",
              { staticClass: "select-province" },
              [
                _c("cc-select", {
                  class: { errorBorder: !_vm.provinceId },
                  attrs: {
                    width: 160,
                    labelKey: "name",
                    valueKey: "provinceId",
                    options: _vm.listProvince,
                    isSearch: true
                  },
                  on: {
                    change: function($event) {
                      return _vm.selectProvince(
                        _vm.provinceId,
                        _vm.listProvince
                      )
                    }
                  },
                  model: {
                    value: _vm.provinceId,
                    callback: function($$v) {
                      _vm.provinceId = $$v
                    },
                    expression: "provinceId"
                  }
                })
              ],
              1
            )
          ]),
          _vm.sendType == 1 || _vm.sendType == 4
            ? _c("div", { staticClass: "z-title p-l12" }, [_vm._v("送餐城市")])
            : _c("div", { staticClass: "z-title p-l12" }, [_vm._v("取餐城市")]),
          _c("div", { staticClass: "z-content" }, [
            _c(
              "div",
              { staticClass: "select-province" },
              [
                _c("cc-select", {
                  staticClass: "select",
                  class: { errorBorder: !_vm.cityId },
                  attrs: {
                    width: 160,
                    labelKey: "name",
                    valueKey: "cityId",
                    options: _vm.listCity,
                    isSearch: true
                  },
                  on: {
                    change: function($event) {
                      return _vm.selectCity(_vm.cityId, _vm.listCity)
                    }
                  },
                  model: {
                    value: _vm.cityId,
                    callback: function($$v) {
                      _vm.cityId = $$v
                    },
                    expression: "cityId"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "z-title p-l12" }, [_vm._v("区域")]),
          _c("div", { staticClass: "z-content" }, [
            _c(
              "div",
              { staticClass: "select-province" },
              [
                _c("cc-select", {
                  staticClass: "select",
                  class: { errorBorder: !_vm.districtId },
                  attrs: {
                    width: 160,
                    labelKey: "name",
                    valueKey: "districtId",
                    options: _vm.listDistrict,
                    isSearch: true
                  },
                  on: {
                    change: function($event) {
                      return _vm.selectdistrict(
                        _vm.districtId,
                        _vm.listDistrict
                      )
                    }
                  },
                  model: {
                    value: _vm.districtId,
                    callback: function($$v) {
                      _vm.districtId = $$v
                    },
                    expression: "districtId"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm.sendType == 1 || _vm.sendType == 4
          ? _c("li", [
              _c("div", { staticClass: "z-title" }, [_vm._v("大厦/小区/学校")]),
              _c(
                "div",
                {
                  staticClass: "z-content",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.searchClick.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "detailsearch" }, [
                    _c("div", { staticClass: "searchBox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.consigneeAddress,
                            expression: "consigneeAddress"
                          }
                        ],
                        ref: "addressElement",
                        staticClass: "text detailadd",
                        attrs: { id: "address", autocomplete: "off" },
                        domProps: { value: _vm.consigneeAddress },
                        on: {
                          focus: function($event) {
                            _vm.islistShow = true
                          },
                          blur: _vm.hideList,
                          keyup: function($event) {
                            return _vm.inputAddress()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.consigneeAddress = $event.target.value
                          }
                        }
                      }),
                      _c("i", { staticClass: "cross" }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.islistShow &&
                                (_vm.addressList.length ||
                                  _vm.lastConsigneeAddress.length ||
                                  _vm.consigneeAddress.length),
                              expression:
                                "islistShow&&(addressList.length ||  lastConsigneeAddress.length || consigneeAddress.length )"
                            }
                          ],
                          ref: "detailSearchEle",
                          staticClass: "list-containter",
                          style: _vm.detailSearchStyle
                        },
                        [
                          _c(
                            "ul",
                            [
                              _vm.islistShow &&
                              ((_vm.lastConsigneeAddress &&
                                _vm.lastConsigneeAddress.length > 0) ||
                                (_vm.addressList &&
                                  _vm.addressList.length > 0)) &&
                              _vm.consigneeAddress.length === 0
                                ? [
                                    _vm._l(_vm.lastConsigneeAddress, function(
                                      item,
                                      index
                                    ) {
                                      return _vm.lastConsigneeAddress &&
                                        _vm.lastConsigneeAddress.length > 0
                                        ? _c(
                                            "li",
                                            {
                                              key:
                                                _vm.lastConsigneeAddress
                                                  .length +
                                                "-" +
                                                index,
                                              staticClass: "list-item",
                                              on: {
                                                mousedown: function($event) {
                                                  return _vm.checkAddress(item)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "Poptip",
                                                {
                                                  staticClass: "am-block",
                                                  attrs: {
                                                    trigger: "hover",
                                                    placement: "right",
                                                    transfer: ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: { slot: "title" },
                                                      slot: "title"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "list-item-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.name)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "list-item-content"
                                                    },
                                                    [
                                                      item.isHistory
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "z-tip-his"
                                                            },
                                                            [_vm._v("历史地址")]
                                                          )
                                                        : _vm._e(),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    }),
                                    _vm._l(_vm.addressList, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                          staticClass: "list-item",
                                          on: {
                                            mousedown: function($event) {
                                              return _vm.checkAddress(item)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "Poptip",
                                            {
                                              staticClass: "am-block",
                                              attrs: {
                                                trigger: "hover",
                                                placement: "right",
                                                transfer: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "title" },
                                                  slot: "title"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "list-item-text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.district) +
                                                          _vm._s(item.name)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "list-item-text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.address)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "list-item-content"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "am-text-truncate"
                                                    },
                                                    [
                                                      item.isHistory
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "z-tip-his"
                                                            },
                                                            [_vm._v("历史地址")]
                                                          )
                                                        : _vm._e(),
                                                      item.isWhite
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "z-tip-black"
                                                            },
                                                            [_vm._v("白名单")]
                                                          )
                                                        : _vm._e(),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        )
                                                      ]),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "list-item-text am-padding-left-sm"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.district
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  item.address
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "am-text-truncate list-item-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                item.address
                                                              ) +
                                                              "\n                          "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    })
                                  ]
                                : _vm._e(),
                              _vm.islistShow &&
                              _vm.addressList &&
                              _vm.addressList.length > 0 &&
                              _vm.consigneeAddress.length > 0
                                ? _vm._l(_vm.addressList, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "li",
                                      {
                                        key: index,
                                        staticClass: "list-item",
                                        on: {
                                          mousedown: function($event) {
                                            return _vm.checkAddress(item)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "Poptip",
                                          {
                                            staticClass: "am-block",
                                            attrs: {
                                              trigger: "hover",
                                              placement: "right",
                                              transfer: ""
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "title" },
                                                slot: "title"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "list-item-text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.district) +
                                                        _vm._s(item.name)
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "list-item-text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(item.address)
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "list-item-content"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "am-text-truncate"
                                                  },
                                                  [
                                                    item.isHistory
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "z-tip-his"
                                                          },
                                                          [_vm._v("历史地址")]
                                                        )
                                                      : _vm._e(),
                                                    item.isWhite
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "z-tip-black"
                                                          },
                                                          [_vm._v("白名单")]
                                                        )
                                                      : _vm._e(),
                                                    _c("span", [
                                                      _vm._v(_vm._s(item.name))
                                                    ]),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "list-item-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.district)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                item.address
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "am-text-truncate list-item-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              item.address
                                                            ) +
                                                            "\n                          "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  })
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm.historyAddressList.length
                    ? _c(
                        "a",
                        {
                          staticClass: "light am-margin-left-sm",
                          on: { click: _vm.showHistoryAddressList }
                        },
                        [_vm._v("查看历史地址")]
                      )
                    : _vm._e()
                ]
              ),
              _c("div", { staticClass: "z-title p-l12" }, [_vm._v("详细地址")]),
              _c("div", { staticClass: "z-content" }, [
                _c("div", { staticClass: "detailsearch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.detailAddress,
                        expression: "detailAddress"
                      }
                    ],
                    staticClass: "text detailadd",
                    attrs: { id: "appendAddress" },
                    domProps: { value: _vm.detailAddress },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.detailAddress = $event.target.value
                      }
                    }
                  }),
                  _c("i", { staticClass: "cross" })
                ])
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cf77491", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cf77491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Pages/modifyOrder/modifyOrderInfo.vue
// module id = WBXb
// module chunks = 1 2